module.exports = __webpack_public_path__ + "static/media/allison.ac2fcc91.png";